const sendToServer = async (level, message, data = {}) => {
  try {
    await fetch('/client-log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        level,
        message,
        data,
        userAgent: navigator.userAgent,
        timestamp: Date.now()
      })
    });
  } catch (error) {
    // Silently fail - don't want logging to break the app
    console.warn('Failed to send log to server:', error);
  }
};

export const clientLogger = {
  info: (message, data) => {
    console.log(`[CLIENT] ${message}`, data);
    sendToServer('info', message, data);
  },
  
  warn: (message, data) => {
    console.warn(`[CLIENT] ${message}`, data);
    sendToServer('warn', message, data);
  },
  
  error: (message, data) => {
    console.error(`[CLIENT] ${message}`, data);
    sendToServer('error', message, data);
  },
  
  // Special method for audio debugging
  audioDebug: (event, details) => {
    const data = {
      event,
      ...details,
      audioContext: {
        state: window.AudioContext ? new AudioContext().state : 'not-supported',
        sampleRate: window.AudioContext ? new AudioContext().sampleRate : null
      },
      deviceInfo: {
        platform: navigator.platform,
        vendor: navigator.vendor,
        maxTouchPoints: navigator.maxTouchPoints,
        isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent)
      }
    };
    
    console.log('[CLIENT AUDIO]', event, data);
    sendToServer('info', `Audio Debug: ${event}`, data);
  }
};